import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class BaladyApiLog
 *
 * @property {number} id
 */
export class BaladyApiLog extends Model {


}

AccessorsMutatorsDecorator(
    'id',
    'property_id',
    'request_id',
    'is_success',
    'requested_at',
    'request_body',
    'responded_at',
    'response_body'
)(BaladyApiLog);



// WEBPACK FOOTER //
// ./src/pms-api/models/balady-api-log.model.js